// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { useParams } from 'react-router-dom';
// import { API_PATH } from '../Constant/constants';

// const AppointmentDetails = () => {
//   const { appointmentId } = useParams();
//   const [appointment, setAppointment] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchAppointment = async () => {
//       try {
//         const response = await axios.get(
//           `${API_PATH}/appointments/${appointmentId}`
//         );
//         setAppointment(response.data);
//       } catch (err) {
//         setError('Failed to fetch appointment.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAppointment();
//   }, [appointmentId]);

//   if (loading) return <div className="text-center mt-5">Loading...</div>;
//   if (error) return <div className="text-danger text-center mt-5">{error}</div>;
//   if (!appointment) return <div className="text-center mt-5">No appointment found.</div>;

//   return (
//     <div className="container mt-5">
//       <div className="card shadow">
//         <div className="card-header bg-primary text-white text-center">
//           <h3>Appointment Details</h3>
//         </div>
//         <div className="card-body">
//           <div className="row g-3">
//             <Info label="Appointment ID" value={appointment.id} />
//             <Info label="Slot ID" value={appointment.slotId} />
//             <Info label="Doctor ID" value={appointment.doctorId} />
//             <Info label="Patient Name" value={`${appointment.patientFirstName} ${appointment.patientLastName}`} />
//             <Info label="Email" value={appointment.patientEmail} />
//             <Info label="Phone" value={appointment.patientNumber} />
//             <Info label="Address" value={appointment.patientAddress} />
//             <Info label="Date" value={appointment.appointmentDate} />
//             <Info label="Time" value={`${appointment.startTime} - ${appointment.endTime}`} />
//             <Info label="Reason" value={appointment.reason} />
//             <Info label="Status" value={appointment.status} />
//             <Info label="Appointment Type" value={appointment.appointmentType} />
//             <Info label="Priority" value={appointment.priority} />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const Info = ({ label, value }) => (
//   <div className="col-md-6">
//     <div className="border rounded p-3 bg-light">
//       <strong className="text-secondary d-block">{label}</strong>
//       <span className="text-dark">{value || '—'}</span>
//     </div>
//   </div>
// );

// export default AppointmentDetails;







import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { API_PATH } from '../Constant/constants';
import useAuth from '../config/useAuth'; // ✅ Import your custom auth hook

const AppointmentDetails = () => {
  const { appointmentId } = useParams();
  const { token } = useAuth(); // ✅ Get token from auth context
  const [appointment, setAppointment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAppointment = async () => {
      try {
        const response = await axios.get(
          `${API_PATH}/appointments/${appointmentId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setAppointment(response.data);
      } catch (err) {
        console.error(err);
        setError('Failed to fetch appointment.');
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchAppointment();
    } else {
      setError('Unauthorized. Token missing.');
      setLoading(false);
    }
  }, [appointmentId, token]);

  if (loading) return <div className="text-center mt-5">Loading...</div>;
  if (error) return <div className="text-danger text-center mt-5">{error}</div>;
  if (!appointment) return <div className="text-center mt-5">No appointment found.</div>;

  return (
    <div className="container mt-5 w-100 mw-100">
      <div className="card shadow">
        <div className="card-header  text-white text-center" style={{ backgroundColor: '#217670' }}>
          <h3>Appointment Details</h3>
        </div>
        <div className="card-body">
          <div className="row g-3">
            {/* <Info label="Appointment ID" value={appointment.id} />
            <Info label="Slot ID" value={appointment.slotId} />
            <Info label="Doctor ID" value={appointment.doctorId} /> */}
            <Info label="Patient Name" value={`${appointment.patientFirstName} ${appointment.patientLastName}`} />
            <Info label="Email" value={appointment.patientEmail} />
            <Info label="Phone" value={appointment.patientNumber} />
            <Info label="Address" value={appointment.patientAddress} />
            <Info label="Date" value={appointment.appointmentDate} />
            <Info label="Time" value={`${appointment.startTime} - ${appointment.endTime}`} />
            <Info label="Reason" value={appointment.reason} />
            <Info label="Status" value={appointment.status} />
            <Info label="Appointment Type" value={appointment.appointmentType} />
            <Info label="Priority" value={appointment.priority} />
          </div>
        </div>
      </div>
    </div>
  );
};

const Info = ({ label, value }) => (
  <div className="col-md-6">
    <div className="border rounded p-3 bg-light">
      <strong className="text-secondary d-block" style={{ color: '#217670' }}>{label}</strong>
      <span className="text-dark">{value || '—'}</span>
    </div>
  </div>
);

export default AppointmentDetails;
